import { compose, applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';

import { reducer as appReducer } from './features/app';
import { reducer as localeReducer } from './features/locale';
import { reducer as authReducer } from './features/Auth';
import { reducer as notifyReducer } from './features/notify';
import { reducer as transactionReduces } from './features/transaction';
import { reducer as users } from './features/users/redux';
import { actionFilter } from 'services/timer';
import { reducer as totalReducee } from './features/Total';
import { reducer as treeReducer } from './features/tree';
import { reducer as promotionsReducer } from './features/promotions';
import { reducer as paymentReducer } from './features/payment';
import { reducer as statisticReducer } from './features/statistic';
import { reducer as notificationReducer } from './features/notifications';
import { reducer as slotsHistoryReducer } from './features/slotsHistory/redux';

function configureStore(extra) {
  const middlewares = [thunk.withExtraArgument(extra), actionFilter];

  const reducer = createReducer();

  // TODO: отключить devtools в production
  const store = createStore(
    reducer,
    compose(
      applyMiddleware(...middlewares),
      persistState(['userSettings', 'auth']),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true }) : arg => arg,
    ),
  );

  return store;
}

function createReducer() {
  return combineReducers({
    app: appReducer,
    locale: localeReducer,
    auth: authReducer,
    notify: notifyReducer,
    users: users,
    total: totalReducee,
    transaction: transactionReduces,
    tree: treeReducer,
    promotions: promotionsReducer,
    payment: paymentReducer,
    statistic: statisticReducer,
    notifications: notificationReducer,
    slotsHistory: slotsHistoryReducer,
  });
}

export { createReducer };
export default configureStore;
